import { jsonldPerformerUrl } from './JsonldStore';

export const updateJsonldPerformerUrl = (value) => jsonldPerformerUrl.update((oldValue) => value);
